import { ref } from "vue";

export const PlBlockPageTitleTeleportTarget = ref<HTMLElement | null>();
